import {mapActions, mapGetters, mapMutations} from 'vuex';
import paginationMixin from '@/mixins/pagination/index.js'

export default {
    components:{
        Header: ()=> import('../../components/header/index.vue'),
        leftBar: ()=> import('../../components/left-bar/index.vue'),
        Table: ()=> import('../../components/table/list/index.vue'),
        TableOptions: ()=> import('../../components/table/options/index.vue'),
        PopupNp: ()=> import('@/components/popups/plugins/nova-poshta/index.vue'),
        PopupTurboSms: ()=> import('@/components/popups/plugins/turboSms/index.vue'),
        PopupBinotel: ()=> import('@/components/popups/plugins/binotel/index.vue'),
        PopupCheckbox: ()=> import('@/components/popups/plugins/checkbox/index.vue'),
        pagination: ()=> import('@/components/pagination/index.vue'),
    },
    mixins: [paginationMixin],
    data(){
        return{
            // Статичні визначення полів: перекладні підписи — labelKey,
            // сам `label` обчислюється в computed fields (залежить від локалі).
            fieldDefs:[
                {
                    key: 'moduleTitle',
                    labelKey: 'plugins.title'
                },
                {
                    key: 'np_logo',
                    labelKey: 'plugins.logo'
                },
                {
                    key: 'module',
                    labelKey: 'plugins.module'
                },
                {
                    key: 'description',
                    labelKey: 'plugins.description'
                },
                {
                    key: 'status',
                    labelKey: 'plugins.activation'
                },
            ],
            items:[],
            showPopup: false,
            showPopupTurboSms: false,
            showPopupBinotel: false,
            showPopupCheckbox: false,
            selectedItem: null,
            list:[
                {
                    np_title:'Нова Пошта',
                    np_logo:'np',
                    np_module:'nova_poshta',
                    np_description: this.$t('plugins.np_desc'),
                    np_status:1,
                    np_area:'',
                    np_phone:'',
                    np_firstname:'',
                    np_lastname:'',
                    np_middlename:'',
                    np_api_key:'',
                },
                {
                    np_title:'ТурбоСМС',
                    np_logo:'turboSms',
                    np_module:'turbosms',
                    np_description: this.$t('plugins.turbo_desc'),
                    np_status:1,
                },
                {
                    np_title:'Бинотел',
                    np_logo:'binotel',
                    np_module:'binotel',
                    np_description: this.$t('plugins.binotel_desc'),
                    np_status:1,
                },
                {
                    np_title:'Checkbox',
                    np_logo:'checkbox',
                    np_module:'checkbox',
                    np_description: this.$t('plugins.checkbox_desc'),
                    np_status:1,
                },
            ]
        }
    },
    computed: {
        fields() {
            return this.fieldDefs.map(field => field.labelKey
                ? { ...field, label: this.$t(field.labelKey) }
                : field);
        },
        ...mapGetters({
            menuHide:'config/menuHide',
            options:'config/options',
            warehouse:'warehouse/warehouse',
        })
    },
    watch:{
        page(e) {
            this.getWarehouses({page: e, perpage: this.perPage});
        },
        perPage(e) {
            this.getWarehouses({page: this.page, perpage: e});
        },
        options(e){
            if(e.models.length || e.models.length){
                e.models[0].map(item=>{
                    this.items.push({
                        moduleTitle: item.np_title,
                        np_logo: item.np_logo,
                        module: item.np_module,
                        description: item.np_description,
                        status: Boolean(item.np_status)
                    });
                })
            }else{
                this.items = []

                this.list.map(item=>{
                    this.items.push({
                        moduleTitle: item.np_title,
                        np_logo: item.np_logo,
                        module: item.np_module,
                        description: item.np_description,
                        status: Boolean(item.np_status)
                    });
                })
            }
            this.res = e
        }
    },
    created() {
        this.toggleLoadingStatus(true);
        this.getWarehouses({page: 1, perpage: this.perPage}).then(()=>{
            this.toggleLoadingStatus(false);
        });
        this.getOptions();
    },
    methods:{
        changePopup(item){
            this.showOption(item.id)
            if(item.module === 'nova_poshta'){
                this.showPopup = true;
            }else if(item.module === 'turbosms'){
                this.showPopupTurboSms = true;
            }else if(item.module === 'binotel'){
                this.showPopupBinotel = true;
            }else if(item.module === 'checkbox'){
                this.showPopupCheckbox = true;
            }
        },
        editClickWarehouse(item){
            this.showWarehouse(item.id)
            this.showPopup = true;
        },
        selectItem(item){
            if(item.length){
                this.selectedItem = item;
            }else{
                this.selectedItem = null;
            }
        },
        sendOptions(form){
            this.editOptions(form).then(res=>{
                if(res.result){
                    this.getOptions();
                    this.$toasted.success(this.$t('toasts.np_updated'),{
                        duration : 3000
                    });
                }
                this.showPopup = false;
            })
        },
        changeOptions(form){
            this.editOptions(form).then(res=>{
                if(res.result){
                    this.getOptions();
                    this.$toasted.success(this.$t('toasts.settings_saved'),{
                        duration : 3000
                    });
                    this.showPopup = false;
                }
            }).catch(err => {
                console.error('Error saving settings:', err);
                this.$toasted.error(this.$t('toasts.settings_err'),{
                    duration : 3000
                });
            })
        },
        removeItem(id){
          this.removeWarehouse(id).then(res=>{
              if(res.status){
                  this.getWarehouses();
                  this.$toasted.success(this.$t('toasts.plugin_deleted'),{
                      duration : 3000
                  });
                  this.showPopup = false;
              }
          })
        },
        ...mapActions({
            getWarehouses:'warehouse/getWarehouses',
            addWarehouse:'warehouse/addWarehouse',
            showWarehouse:'warehouse/showWarehouse',
            editWarehouse:'warehouse/editWarehouse',
            removeWarehouse:'warehouse/removeWarehouse',
            getNpAreas:'plugins/getNpAreas',
            getOptions:'config/getOptions',
            editOptions:'config/editOptions',
        }),
        ...mapMutations({
            toggleLoadingStatus: 'config/toggleLoadingStatus',
            showOption: 'config/showOption',
        })
    }
}
